"use strict";
/* eslint-disable camelcase */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BeCropReport_1 = __importDefault(require("./BeCropReport"));
class Report {
    constructor(newReport) {
        this.id = newReport.id || -1;
        this.c_muestra_wineseq = newReport.c_muestra_wineseq || '#000000';
        this.client_reference = newReport.client_reference || '#Ref';
        this.c_estado = newReport.c_estado || -1;
        this.parcel = newReport.parcel || null;
        if (newReport.becrop_report) {
            this.becrop_report = new BeCropReport_1.default(newReport.becrop_report);
        }
        else {
            this.becrop_report = new BeCropReport_1.default({});
        }
        this.becrop_report_shi = newReport.becrop_report_shi || { shi_rank: 0 };
        this.fecha_muestra = newReport.fecha_muestra || 'TBD';
        this.variety = newReport.variety || 'TBD';
        this.tierra = newReport.tierra || null;
        this.projects = newReport.projects || [];
        this.proposal = newReport.proposal || null;
    }
    get reportWineseq() {
        return this.c_muestra_wineseq;
    }
    get reportClient() {
        return this.client_reference;
    }
    get reportEstado() {
        return this.c_estado;
    }
    get reportParcel() {
        return this.parcel;
    }
    get reportBecrop() {
        return this.becrop_report;
    }
    get reportBecropSHI() {
        return this.becrop_report_shi;
    }
}
exports.default = Report;
